/**
 * A list read as a sentence: "a", "a and b", "a, b and c".
 *
 * @param items - the words to join
 * @returns the joined phrase
 * @example joinAnd(['haulage cost', 'truck type', 'lorry number'])
 *   // "haulage cost, truck type and lorry number"
 */
export function joinAnd(items: string[]): string {
  if (items.length <= 1) return items.join('');
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
}
